import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaBehance,
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-black text-white">

      <div className="max-w-7xl mx-auto px-6 py-20">

        <div className="grid lg:grid-cols-4 gap-14">

          {/* Logo */}

          <div>

            <h2 className="text-5xl font-black mb-6">
              TA
            </h2>

            <p className="text-gray-400 leading-8">
              Creative Photographer &
              Digital Artist creating
              memorable visual experiences.
            </p>

          </div>

          {/* Menu */}

          <div>

            <h4 className="font-bold text-xl mb-6">
              Navigation
            </h4>

            <ul className="space-y-4 text-gray-400">

              <li><a href="#home">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#portfolio">Portfolio</a></li>
              <li><a href="#about">About</a></li>

            </ul>

          </div>

          {/* Contact */}

          <div>

            <h4 className="font-bold text-xl mb-6">
              Contact
            </h4>

            <ul className="space-y-4 text-gray-400">

              <li>hello@email.com</li>
              <li>+1 234 567 890</li>
              <li>New York, USA</li>

            </ul>

          </div>

          {/* Social */}

          <div>

            <h4 className="font-bold text-xl mb-6">
              Follow Me
            </h4>

            <div className="flex gap-4">

              {[
                <FaFacebookF />,
                <FaInstagram />,
                <FaLinkedinIn />,
                <FaBehance />,
              ].map((icon, i) => (

                <a
                  key={i}
                  href="/"
                  className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center hover:bg-red-500 transition"
                >
                  {icon}
                </a>

              ))}

            </div>

          </div>

        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row justify-between text-gray-500 text-sm">

          <p>
            © 2026 Taikhoom Amir. All rights reserved.
          </p>

          <p>
            Designed with React & Tailwind CSS
          </p>

        </div>

      </div>

    </footer>
  );
}